import { render, staticRenderFns } from "./LojaManutencao.vue?vue&type=template&id=4c1cced1&scoped=true&"
import script from "./LojaManutencao.vue?vue&type=script&lang=js&"
export * from "./LojaManutencao.vue?vue&type=script&lang=js&"
import style0 from "./LojaManutencao.vue?vue&type=style&index=0&id=4c1cced1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c1cced1",
  null
  
)

export default component.exports